export class Pie {
  constructor(difference) {
    this.width = 450
    this.height = 300
    this.top = 10
    this.left = 10
    this.type = "pie3D"
    this.typeName = "3D饼图"
    this.innerElement = "cxPie3D"
    this.refreshTime = 1000 //间隔刷新时间
    this.updateTimer = 600 // 数据源轮询时间
    // 是否自动播放tooltip
    this.isAutoPlayToolTip = false
    this.autoPlayToolTipIntervalTime = 1000
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.opacity = 100
    this.initOptions = {
      renderer: "canvas"
    }
    this.init(difference)
  }
  init(difference) {
    this.chartOption = difference
    // for (let key in difference) {
    //   this[key] = difference[key]
    // }
  }
}
export class homePie {
  constructor(difference) {
    this.width = 4
    this.height = 300
    this.top = 10
    this.left = 10
    this.type = "Pie"
    this.typeName = "柱状图"
    this.innerElement = "cxPie"
    this.animateSets = {
      animateType: 0,
      animateDirection: "无",
      animateDuration: 1.5,
      animateDelay: 0,
      hasDirection: false,
      animateTriggerNumType: "单次触发",
      animateClass: "",
      executionAnimateClass: ""
    }
    this.refreshTime = 1000 //间隔刷新时间
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.initOptions = {
      renderer: "canvas"
    }
    this.init(difference)
  }
  init(difference) {
    this.chartOption = difference
    // for (let key in difference) {
    //   this[key] = difference[key]
    // }
  }
}
